import { Share } from 'lucide-react'
import { BaseButton, BaseCard, BaseTooltip } from '@/shared/components'
import { useState } from 'react'
import { ShareLinkDialog } from '../../dialogs/ShareLinkDialog'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'

interface ReferralCodeCardProps {
  referallCode?: string
}

export const ReferralCodeCard = ({ referallCode }: ReferralCodeCardProps) => {
  const [modalVisible, setModalVisible] = useState(false)

  const referallLink = referallCode ? `https://syncra.me/register?referall=${referallCode}` : ''

  const handleShare = () => {
    setModalVisible(true)
  }

  return (
    <BaseCard
      padding="md"
      radius="md"
      variant="active"
      className="flex xl:flex-row flex-col justify-between gap-10 lg:gap-4 xl:gap-2 w-full min-w-[300px]"
    >
      <div className="flex flex-col flex-1 justify-between gap-2">
        <div className="flex items-center gap-[10px] font-klein font-medium text-text-secondary whitespace-nowrap">
          Ваш реферальный код
          <BaseTooltip text="Ваш реферальный код" />
        </div>
        <div className="flex items-center gap-[10px]">
          <CopyBlock text={referallCode} className="font-klein font-medium text-lg" size="base">{referallCode ?? 'Нет данных'}</CopyBlock>
        </div>
      </div>
      <div>
        <BaseButton
          variant="setting"
          padding="none"
          radius="md"
          className="bg-white py-3 w-full md:w-[225px]"
          iconPosition="right"
          onClick={handleShare}
          icon={<Share className="w-5 h-5 text-primary dark:text-primary-dark" />}
        >
          Поделиться ссылкой
        </BaseButton>

        <ShareLinkDialog
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          referralLink={referallLink}
        />
      </div>
    </BaseCard>
  )
}
